module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Brush-1532c2e743e38c9847752da03783ff4a8c3e6bbcbfcb39500ca48f67fce4fda2.svg";